<template>
  <div class="coupon-choose">
    <nav-bar class="header">请选择优惠券</nav-bar>
    <VanList v-if="showList" :finished="true" class="content">
      <coupon-choose-card
          v-for="(card, index) in couponList"
          :key="index"
          :data-source="card"
          :active-id="selectedId"
          style="width:100%;"
          @choose="onChoose"
        />
    </VanList>
		<div class="bottom">
      <div class="left">
        <div v-html="couponText" class="text"></div>
      </div>
      <div class="right" @click="onConfirm">确认</div>
    </div>
  </div>
</template>
<script>
import { fenToYuan } from '@/utils';
import NavBar from '../../components/nav-bar/index'
import CouponChooseCard from './components/coupon-choose-card'
import { getValidCoupons } from './mgr/index'

const DO_NOT_USE_COUPON = 'no'

export default {
  name: 'CllCouponChoose',
  components: { CouponChooseCard, NavBar },
  data() {
    return {
      showList: false,
      couponList: [],
      selectedId: DO_NOT_USE_COUPON,
    }
  },
  computed: {
    couponText() {
      if (!this.selectedId || this.selectedId === DO_NOT_USE_COUPON) {
        return '不使用优惠券'
      }
      const coupon = this.couponList.find(item => item.couponId === this.selectedId)
      if (coupon) {
        return `优惠金额 ¥<span style="font-size:24px;">${fenToYuan(coupon.money)}</span>`
      }
      return ''
    }
  },
  beforeRouteEnter(to, from, next) {
    const { name, params } = to || {}
    if (name === 'choose') {
      const { couponId } = params || {}
      next(vm => {
        vm.selectedId = couponId || DO_NOT_USE_COUPON
        console.log('choose selectedId:', vm.selectedId)
      })
    } else {
      next()
    }
  },
  mounted() {
    this.requestValidCoupons()
  },
  activated() {
    this.showList = true
    this.requestValidCoupons()
  },
  deactivated() {
    this.showList = false
  },
  methods: {
    // 请求获取可用优惠劵
    requestValidCoupons() {
      const userId = this.$UserService.getUserId()
      const cityId = this.$AppService.getCityId()
      const lineId = this.$route.query.areaId
      const otherParams = this.$route.query.price ? {price: this.$route.query.price}: {}
      return getValidCoupons({
        bigCityId: cityId,
        cityId,
        userId,
        lineId,
        ...otherParams
      }).then(res => {
        console.log('getValidCoupons res:', res)
        this.couponList = res || []
      })
    },
    onChoose(couponId) {
      this.selectedId = couponId
    },
    onConfirm() {
      this.$route.params.couponId = this.selectedId
      this.goBack()
    },
    goBack() {
      let timer = setTimeout(() => {
        clearTimeout(timer)
        timer = 0
        this.$router.go(-1)
      }, 0)
    },
  }
}
</script>

<style lang="scss" scoped>
.coupon-choose {
  background: #F3F4F5;
  .header {
    position: fixed;
    z-index:1000;
    height: 48px;
  }
  .content {
    min-height: 100vh;
    padding: 58px 10px 0 10px;
    padding-bottom: calc(80px + constant(safe-area-inset-bottom));
    padding-bottom: calc(80px + env(safe-area-inset-bottom));
  }

  .bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 20px 0 20px;
    padding-bottom: calc(20px + constant(safe-area-inset-bottom));
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
    box-shadow: 0px -2px 8px 0px #D7E3EA;
    background: #ffffff;
    display: flex;
  }
  .left {
    flex: 1;
    height: 48px;
    background: #E1EEFF;
    box-shadow: 0px 2px 8px 0px rgba(185,185,185,0.5);
    border-radius: 25px 0px 0px 25px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }

  .text {
    display: flex;
    align-items: baseline;
  }
  
  .right {
    width: 112px;
    height: 48px;
    background: linear-gradient( 90deg, #00A7FD 0%, #006EFA 100%);
    box-shadow: 0px 2px 8px 0px rgba(185,185,185,0.5);
    border-radius: 0px 24px 24px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 25px;
    text-align: center;
    font-style: normal;
  }
}

</style>

